import { Grid, TextField, MenuItem, Button, Typography, Paper, Snackbar, Alert } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SendIcon from '@mui/icons-material/Send';
import {BarLoader, GridLoader, HashLoader, MoonLoader, PropagateLoader, PuffLoader, PulseLoader} from 'react-spinners'
function LotteryIn() {
    const [dealers,setDealers] = useState([])
    const [DLBlotteries, setDLBLotteries] = useState([])
    const [NLBlotteries, setNLBLotteries] = useState([])
    const [submitLoading,setSubmitLoading] = useState(false)
    const [alertOpen,setAlertOpen] = useState(false)
    const [loading,setLoading] = useState(true)
    const [search,setSearch] = useState('')

    const [dealername,setDealerName] = useState('')

    
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getTomorrowDate = () => {
        const today = new Date();
        // Add one day to the current date
        today.setDate(today.getDate() + 1);
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    useEffect( () => {
         axios.post('https://servermunidasa.ccsoftwares.com/lottery/getLotteryInByEntity',{"entity" : "DLB"}).then(res => {
            // console.log(res.data)
            setDLBLotteries(res.data)
        }).catch((e) => {
            alert(e)
        }) 

         axios.post('https://servermunidasa.ccsoftwares.com/lottery/getLotteryInByEntity',{"entity" : "NLB"}).then(res => {
            // console.log(res.data)
            setNLBLotteries(res.data)

        }).catch((e) => {
            alert(e)
        }) 
         axios.get('https://servermunidasa.ccsoftwares.com/Dealers/getDealers').then(res => {
            // console.log(res.data)
            setDealers(res.data)
            setLoading(false)
            setDealerName(res.data[0].full_name)

        }).catch((e) => {
            alert(e)
        }) 




    }, [])
    

    const [formData, setFormData] = useState({
        lotteryBoard: 'NLB',
        lottery: '',
        qty: '',
        unitPrice: '32.50',
        total: '',
        drawDate : getTomorrowDate(),
      });


      const handleChange = (e) => {
        console.log(e)
        const { name, value } = e.target;

        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
          total: name === 'qty' || name === 'unitPrice' ? calculateTotal({ ...prevData, [name]: value }) : prevData.total,
        }));
      };


    const calculateTotal = (data) => {
        const qty = parseFloat(data.qty) || 0;
        const unitPrice = parseFloat(data.unitPrice) || 0;
        return (qty * unitPrice).toFixed(2); 
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertOpen(false);
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true)
        const {lotteryBoard,lottery,qty,unitPrice,total,drawDate} = formData;
        const newFormData = {lotteryBoard,lottery,qty,unitPrice,total,dealername,drawDate}
        // console.log('Form Data Submitted: ', newFormData);
        await axios.post("https://servermunidasa.ccsoftwares.com/ticketin/add",newFormData).then((res) => {
            // alert(res.data.message);

            axios.post("https://servermunidasa.ccsoftwares.com/stock/addStock",{lotteryBoard,lottery,qty,drawDate}).then((res) =>{

                setSubmitLoading(false)
                setAlertOpen(true)
            })

            setFormData({
                lottery: '',
                total: '',
                qty : '',
                lotteryBoard: lotteryBoard,
                unitPrice: '32.50',
                drawDate: getTomorrowDate(),
              });
        }).catch(e => {
            alert(e)
        })


    };


    const selectedDealer  = (e) => {

        setDealerName(e.full_name)
    }

    const navigate = useNavigate();
  return (
    <Grid container style={{marginTop : 40,backgroundColor : "white",overflowY : 'hidden',fontFamily : 'Segoe UI',height : '100%',borderTopLeftRadius : 0, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)'}}>
        <Grid xs = {12} md = {12}>
            <div style={{display : 'flex',alignItems : 'center',justifyContent : 'left',height : 40}}>
            <button
            style={{
                    backgroundColor : 'white',
                    color: 'Black',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 30,
                    marginTop : 10
                }}
                onClick={() => navigate(-1)}
            >
          <ArrowCircleLeftIcon fontSize='2'/>
        </button>
            <div style={{fontFamily : 'Segoe UI',fontSize : 28,fontWeight : '400'}}>
                Ticket In 
            </div>
        </div>

        </Grid>
        <Grid xs = {12} md = {6} style={{backgroundColor : 'white'}}>
            <Paper style={{ padding: '20px', maxWidth: '100%',height : '100%', margin: '0 auto' }}>
                <div style={{marginBottom : 10,marginTop : 10}}>
                <TextField id="outlined-basic" label="Search Dealers" variant="outlined" fullWidth onChange={(e) => {setSearch(e.target.value)}}/>
                </div>
                <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {loading ? (<center><HashLoader size={30} color='Cyan'/></center>) : 
                    
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        {dealers.filter((element) => {
                          if (search === '') {
                              return element
                          }
                          else if ((element.full_name.toLowerCase()).includes(search.toLowerCase()) ) {
                              return element
                              
                          }
                          
                      }).map((element, i) => (
                        <>
                            <tr>
                            <td colSpan={2}>
                                <hr style={{ border: 'none', borderTop: '0px solid black', margin: 0 }} />
                            </td>
                            </tr>
                            <tr
                            style={{
                                backgroundColor: 'white',
                                transition: 'background-color 0.3s ease',
                                height : 20
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                           
                            >
                            <td style={{ textAlign: 'center', fontSize: 14,fontWeight : '600' }}>
                                <div style={{display : 'flex',justifyContent : 'space-between',alignItems : 'center'}}  onClick={() => selectedDealer(element)} >

                                <div style={{display : 'flex'}}>
                                <AccountCircleIcon style={{marginTop : 10}}/>
                                    <div style={{fontSize : 14,textAlign : 'left',margin : 10}}>

                                        Name : {element.full_name}<br></br>
                                        Registration : {element.reg_number}<br></br>
                                        Contact No : {element.mobile_number}<br></br>
                                    
                                    </div>
                                </div>
                                <div>
                                <ArrowForwardIosIcon />
                                </div>
                            </div>

                                </td>
                            </tr>

                            <tr>
                            <td colSpan={2}>
                                <hr style={{ border: 'none', borderTop: '1px solid white', margin: 0 }} />
                            </td>
                            </tr>
                        </>
                        ))}
                    </table>
                    }
                    </div>
            </Paper>
        </Grid>
        <Grid xs = {12} md = {6}>
        <Paper elevation={0} style={{ padding: '20px', maxWidth: '100%',height : '100%' }}>
        <Typography variant="h5" gutterBottom>
            Lottery Purchases
        </Typography>
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                label="Dealer Name"
                name="dealerName"
                fullWidth
                value={dealername}
                onChange={handleChange}
                required
                disabled
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                label="Lottery Board"
                name="lotteryBoard"
                select
                fullWidth
                value={formData.lotteryBoard}
                onChange={handleChange}
                required
                >
                <MenuItem value="DLB">DLB</MenuItem>
                <MenuItem value="NLB">NLB</MenuItem>
                </TextField>
            </Grid>

            {formData.lotteryBoard === 'DLB' ? (
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Lottery"
                                name="lottery"
                                select
                                fullWidth
                                value={formData.lottery}  
                                onChange={handleChange}
                                required
                            >
                                {DLBlotteries.map((e,i) => (
                                        <MenuItem key={i} value={e.lotteryName}>{e.lotteryName}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>
                ):<>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Lottery"
                                name="lottery"
                                select
                                fullWidth
                                value={formData.lottery}  
                                onChange={handleChange}
                                required
                            >
                                {NLBlotteries.map((e,i) => (
                                        <MenuItem key={i} value={e.lotteryName}>{e.lotteryName}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>
                
                </>}

            <Grid item xs={12} sm={6}>
                <TextField
                label="Qty"
                name="qty"
                type="number"
                fullWidth
                value={formData.qty}
                onChange={handleChange}
                required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                label="Unit Price"
                name="unitPrice"
                type="number"
                fullWidth
                value={formData.unitPrice}
                onChange={handleChange}
                required
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    label="Draw date"
                    name="drawDate"
                    type="date"
                    fullWidth
                    value={formData.drawDate}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true, 
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12}>
            <TextField
                label="Total"
                name="total"
                fullWidth
                value={formData.total}
                InputProps={{
                style: {
                    color: 'black', 
                    backgroundColor: 'transparent', 
                },
                }}
                InputLabelProps={{
                style: {
                    color: 'black', 
                },
                }}
            />
            </Grid>

            <Grid item xs={6} sm={3} justifyContent="flex-end" style={{marginLeft : '80%'}}>
                {submitLoading ? (<><PulseLoader size = {14} color='#00ffdd' speedMultiplier={1}/></>) : 
                <Button type="submit" variant="outlined" color="primary"  endIcon={<SendIcon />} fullWidth>
                    Submit
                </Button>
                }
            </Grid>
            </Grid>
        </form>
    </Paper>
        </Grid>
           <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
                    Tickets added to the Stock
                </Alert>
            </Snackbar>
    </Grid>
  )
}

export default LotteryIn